import { cerrarSesion } from "../utilities/Seguridad";
import axios from "axios";
const FormData = require("form-data");

export async function getDiagnostico(token) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/configuracion/diagnosticos`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

export async function updateMatricula(idMatricula, adicional, idDiag, obser, token) {
    let data = new FormData();
    data.append("adicional", adicional);
    data.append("idDiagnostico", idDiag);
    data.append("observacion", obser);

    let config = {
        method: "put",
        url: `${process.env.REACT_APP_URL}/matricula-pie/editar/${idMatricula}`,
        headers: {
            Authorization: `Bearer ${token}`,
            ...data,
        },
        data: data,
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

export async function deleteMatricula(idMatricula, token) {
    let config = {
        method: "delete",
        url: `${process.env.REACT_APP_URL}/matricula-pie/eliminar/${idMatricula}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

export async function deleteMatriculaMasivo(idColegio, anio, array, token) {
    let data = new FormData();
    data.append("idColegio", idColegio);
    data.append("anio", anio);
    data.append("data", "[" + array + "]");

    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/matricula-pie/eliminar-masivo`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

export async function RegistroMatricula(dataArray, idColegio, anio, token) {
    let data = new FormData();
    data.append("data", JSON.stringify(dataArray));
    data.append("idColegio", idColegio);
    data.append("anio", anio);

    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/matricula-pie/crear`,
        headers: {
            Authorization: `Bearer ${token}`,
            ...data,
        },
        data: data,
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

export async function getListaMatricula(idColegio, anio, token) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/matricula-pie/listar/${idColegio}/${anio}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

export async function getImportarAlumnos(idColegio, token, file) {

    let data = new FormData();
    data.append("data", JSON.stringify(file));
    //data.append("data", file);
    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/colegio/${idColegio}/cargar-matriculado`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

export async function getImportarAlumnosPrePri(recurso,anio,idColegio, token, file) {

    let data = new FormData();
    data.append("data", file);

    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/colegio/${idColegio}/${recurso}/${anio}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}
